// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8ee2c6e6","826":"c2f8f267"}[chunkId] + ".chunk.js";
};